import { useInView } from '../../../hooks/useInView';

export default function Results() {
  const { ref, inView } = useInView();

  const metrics = [
    { value: '28%', label: 'Average Increase in Lead Conversion' },
    { value: '35%', label: 'Reduction in Administrative Burden' },
    { value: '4x', label: 'Faster Client Response Time' },
    { value: '↑', label: 'Client Retention Across All Verticals' },
  ];

  return (
    <section id="results" className="relative bg-[#0a0f1c] py-40 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/311def59fd85b799cefcd5a4eebf31b0.jpg"
          alt=""
          className="w-full h-full object-cover object-center opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0f1c]/80 via-transparent to-[#0a0f1c]/80" />
      </div>

      <div className="relative max-w-6xl mx-auto px-8">
        <div
          ref={ref}
          className={`text-center mb-24 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-teal-400 text-xs font-semibold tracking-[0.2em] uppercase mb-5">Outcomes</p>
          <h2 className="font-serif text-6xl lg:text-7xl font-bold text-white leading-tight">
            Measurable Elevation.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 rounded-3xl overflow-hidden">
          {metrics.map((m, i) => (
            <div
              key={i}
              className={`bg-[#0d1526]/50 backdrop-blur-sm p-12 text-center transition-all duration-700 hover:bg-[#111d35]/80 ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="font-serif text-7xl lg:text-8xl font-bold text-teal-400 mb-4 leading-none">
                {m.value}
              </div>
              <p className="text-white/50 text-sm leading-relaxed uppercase tracking-wide">{m.label}</p>
            </div>
          ))}
        </div>

        <p className={`text-center text-white/30 text-base mt-12 font-light italic transition-all duration-700 delay-600 ${inView ? 'opacity-100' : 'opacity-0'}`}>
          Structured intelligence creates consistent results.
        </p>
      </div>
    </section>
  );
}
